<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="orders" active="visitor"></v-left>
    <div>
      <div class="filter-dic clearfix">
        <div class="fl">
          <!-- <el-select
            v-model="filter.app_id"
            placeholder="应用"
            size="small"
            class="w160"
            @change="search"
            @clear="search"
            clearable
          >
            <el-option
              v-for="item in $store.state.public.cfg.apps_options"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select> -->
          <el-input v-model="filter.client_id" size="small" class="w200" style="width:133px;" placeholder="client_id"></el-input>
          <el-input v-model="filter.client_ip" size="small" class="w200" style="width:133px" placeholder="client_ip"></el-input>
          <el-input v-model="filter.page_name" size="small" class="w200" style="width:133px" placeholder="page_name"></el-input>
          <el-input v-model="filter.action_name" size="small" class="w200" style="width:133px" placeholder="action_name"></el-input>
          <el-input v-model="filter.button_name" size="small" class="w200" style="width:133px" placeholder="button_name"></el-input>
          <el-date-picker
            size="small"
            style="width: 256px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="fr">
          <el-button size="small" @click="redirect('/orders/diy-create')"
            >作品浏览</el-button
          >
        </div>
      </div>

      <div>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
        <el-table
          :data="list_data.list"
          v-loading="loading"
          style="width: 100%"
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="44"> </el-table-column>
          <el-table-column label="访问记录" width="1200">
            <template slot-scope="scope">
              <el-table
                :data="scope.row.is_record_slide_all ? scope.row.record : scope.row.record_slide"
                v-loading="loading"
                style="width: 100%"
                ref="multipleTable"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                border
              >
                <el-table-column label="client_ip" prop="client_ip" min-width="166"> </el-table-column>
                <el-table-column label="client_id" prop="client_id" min-width="166"> </el-table-column>
                <el-table-column label="page" prop="page_name" min-width="166"> </el-table-column>
                <el-table-column label="action_name" prop="action_name" min-width="166"> </el-table-column>
                <el-table-column label="button_name" prop="button_name" min-width="166"> </el-table-column>
                <el-table-column label="ctime" prop="ctime" min-width="200"> </el-table-column>
              </el-table>
              <a @click="scope.row.is_record_slide_all = !scope.row.is_record_slide_all" class="pointer point">展开（{{scope.row.record.length}}）</a>
            </template>
          </el-table-column>
          <el-table-column label="上传" min-width="166">
            <template slot-scope="scope">
              <el-image
                style="width: 32px"
                :src="diy.file_oss"
                :preview-src-list="[diy.file_oss]"
                v-for="(diy, index) in scope.row.upload_files" :key="index"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="作品" min-width="166"> 
            <template slot-scope="scope">
              <el-image
                style="width: 32px"
                :src="diy.image_diy"
                :preview-src-list="[diy.image_diy]"
                v-for="(diy, index) in scope.row.diy_creates" :key="index"
              >
              </el-image>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>


    </div>
  </div>
</template>

<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_drag = (resolve) => require(["@/pages/orders/_pop_drag"], resolve);
const pop_pro_image = (resolve) =>
  require(["@/pages/orders/_pop_pro_image"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_drag,
    // pop_produce,
    // pop_produce_add,
    pop_pro_image,
  },
  data() {
    return {
      loading: false,
      popName: null,
      pop_diy_info: null,
      edit_row: null,
      edit_order_goods_row: null,
      multipleSelection: [],
      filter: {
        page: 1,
        size: 20,
        app_id:"",
        keyword: "",
        client_id:"",
        client_ip: "",
        action_name: "",
        button_name:"",
        page_name:"",
        time_range: [],
      },
      list_data: {
        size: 20,
        page: 1,
        total: 0,
        list: [],
      },
      order_step_options: [
        { value: 1, label: "未付款" },
        { value: 2, label: "已付款" },
        { value: 3, label: "已生产" },
        { value: 4, label: "已发货" },
        { value: 5, label: "已售后" },
        { value: 6, label: "已完成" },
        { value: 7, label: "已取消" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toEditProImage(row) {
      console.log(row, "------------<<>>>");
      this.edit_order_goods_row = row;
      this.popName = "pop_pro_image";
    },
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toPopProduce(row) {
      this.popName = "pop_produce";
      this.edit_row = row;
    },
    toPopDrag(sub) {
      if (sub.diy_info) {
        this.popName = "pop_drag";
        this.pop_diy_info = sub.diy_info;
      }
    },
    exportExcel() {
      this.$http.post("/orders/export/export", this.filter).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          window.location.href = res.data.file_oss;
        }
      });
    },
    getList() {
      this.loading = true;
      this.$http.post("/v1/pri/statics/visitor-list", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/visitor/Index.vue